import React, { useEffect, useState } from "react";

// ASSETS
import FolderTreeIcon from "assets/icons/FolderTreeIcon.svg";
import PhoneIcon from "assets/icons/PhoneIcon.svg";
import GavelIcon from "assets/icons/GavelIcon.svg";

// STYLES
import {
  OrganizeSectionCardWrapper,
  OrganizeSectionCardsContainer,
  OrganizeSectionContactCardWrapper,
  OrganizeSectionContainer,
  OrganizeSectionSubtitleWrapper,
  OrganizeSectionTitleContainer,
  OrganizeSectionTitleWrapper,
} from "./OrganizeSectionStyled";

// LIBRARIES
import { useTranslation } from "react-i18next";

// MISC
import { IProps } from "./OrganizeSectionModel";
import { TextType } from "components/Atoms/CustomText/CustomTextModel";
import { COLORS } from "constants/variables";
import { CardType } from "components/Atoms/CardAtom/CardAtomModel";
import { appRoutes } from "config/AppRoutesConfig";
import aboutService from "services/aboutService";

// REDUX

// COMPONENTS
import CardAtom from "components/Atoms/CardAtom/CardAtom";
import CustomText from "components/Atoms/CustomText/CustomText";

const OrganizeSection = (props: IProps) => {
  // PROPERTIES

  // LIBRARY CONSTANTS
  const { t } = useTranslation();

  // STATE CONSTANTS
  const [documents, setDocuments] = useState<any>(null);

  // API REQUESTS

  // LIFE CYCLE
  useEffect(() => {
    aboutService
      .getDocumentsWithAttachment()
      .then((response) => {
        // console.log("getDocuments response", response);
        setDocuments(response);
      })
      .catch((err) => {
        console.log("getDocuments error", err);
      });
  }, []);

  // EVENT HANDLERS

  return (
    <OrganizeSectionContainer>
      <OrganizeSectionTitleContainer>
        <OrganizeSectionTitleWrapper>
          <CustomText
            text={t("view.about.aboutDSU.title")}
            type={TextType.H2}
            color={COLORS.VividAuburn}
          />
        </OrganizeSectionTitleWrapper>
        <OrganizeSectionSubtitleWrapper>
          <CustomText
            text={t("view.about.aboutDSU.subtitle")}
            type={TextType.H3}
            color={COLORS.RaisinBlack}
          />
        </OrganizeSectionSubtitleWrapper>
      </OrganizeSectionTitleContainer>
      <OrganizeSectionCardsContainer>
        <OrganizeSectionCardWrapper>
          <CardAtom
            text={documents?.data[0]?.attributes?.title}
            type={CardType.PDF_VIEWER}
            href={`${process.env.REACT_APP_UPLOAD_URL}${documents?.data[0]?.attributes?.attached_document?.data?.attributes?.url}`}
            icon={FolderTreeIcon}
          />
        </OrganizeSectionCardWrapper>
        <OrganizeSectionCardWrapper>
          <CardAtom
            text={t("view.about.aboutRegulations.title")}
            type={CardType.REDIRECT}
            href={appRoutes.legislationRegulations}
            icon={FolderTreeIcon}
          />
        </OrganizeSectionCardWrapper>
        <OrganizeSectionCardWrapper>
          <CardAtom
            text={t("view.about.aboutDSU.organizeSection.legislation")}
            type={CardType.REDIRECT}
            href={appRoutes.legislationOrganisation}
            icon={GavelIcon}
          />
        </OrganizeSectionCardWrapper>
        <OrganizeSectionContactCardWrapper>
          <CardAtom
            text={t("view.about.aboutDSU.organizeSection.contact")}
            type={CardType.CONTACT}
            href={appRoutes.institutionsContact}
            icon={PhoneIcon}
          />
        </OrganizeSectionContactCardWrapper>
      </OrganizeSectionCardsContainer>
    </OrganizeSectionContainer>
  );
};

export default OrganizeSection;
